import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import GoalsPageContainer from './GoalsPageContainer';
import { actions } from './GoalsPageContainer.actions';

const GoalsPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {};
    },
    function mapDispatchToProps(dispatch) {
        return {
            onUpdate: actions.update
        };
    }
)(withRouter(GoalsPageContainer));

export default GoalsPageContainerComponent;
